
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./config/environment.ts"
import * as amdModule1 from "./registry.ts"
import * as amdModule2 from "./router.ts"
import * as amdModule3 from "./services/docs.ts"
import * as amdModule4 from "./services/selected.ts"
import * as amdModule5 from "./utils.ts"
import * as amdModule6 from "./services/page-title.js"
import * as amdModule7 from "./templates/application.gts"
import * as amdModule8 from "./controllers/application.ts"
import * as amdModule9 from "./routes/application.ts"
import * as amdModule10 from "./routes/index.ts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"tutorial/config/environment": amdModule0,
"tutorial/registry": amdModule1,
"tutorial/router": amdModule2,
"tutorial/services/docs": amdModule3,
"tutorial/services/selected": amdModule4,
"tutorial/utils": amdModule5,
"tutorial/services/page-title": amdModule6,
"tutorial/templates/application": amdModule7,
"tutorial/controllers/application": amdModule8,
"tutorial/routes/application": amdModule9,
"tutorial/routes/index": amdModule10,
  },
  exportFastbootModules
);
